<!-- Query ID -->
<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('ou')">{{
            "field.ou" | translate
            }}</label>
          <input type="text" pInputText [ngModel]="ouName" readonly="true" [id]="parseToId('ouName')" />
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('item')">{{
            "field.item-number" | translate
            }}</label>
          <input type="text" pInputText [ngModel]="item" readonly="true" [id]="parseToId('item')" />
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('beginMonth')">{{
            "field.begin-month" | translate
            }}</label>
          <input type="text" pInputText [ngModel]="beginMonth" readonly="true" [id]="parseToId('beginMonth')" />
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('endMonth')">{{
            "field.end-month" | translate
            }}</label>
          <input type="text" pInputText [ngModel]="endMonth" readonly="true" [id]="parseToId('endMonth')" />
        </div>
        <div class="col-12 md:col-3 lg:col-3">
          <label [for]="parseToId('beginBalance')">{{
            "field.begin-balance" | translate
            }}</label>
          <input type="text" pInputText [ngModel]="beginBalance | number : '1.0-0'" readonly="true"
            [id]="parseToId('beginBalance')" />
        </div>
      </div>
    </div>
  </p-panel>
</div>

<div class="bpaas-content">
  <p-panel [showHeader]="false">
    <div class="card" #contentElement pBPaaSFocusTrap>
      <div class="grid p-fluid">
        <ng-container *ngIf="rowSelectedDatas">
          <ng-container *ngIf="showSalesFields">
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('sales')">{{
                "field.sales" | translate
                }}</label>
              <input type="text" pInputText [ngModel]="sales" readonly="true" [id]="parseToId('sales')" />
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('salesName')">{{
                "field.sales-name" | translate
                }}</label>
              <input type="text" pInputText [ngModel]="salesName" readonly="true" [id]="parseToId('salesName')" />
            </div>
          </ng-container>
          <ng-container *ngIf="showPoFields">
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('poNo')">{{
                "field.po-no" | translate
                }}</label>
              <input type="text" pInputText [ngModel]="poNo" readonly="true" [id]="parseToId('poNo')" />
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('poLineNo')">{{
                "field.po-line-no" | translate
                }}</label>
              <input type="text" pInputText [ngModel]="poLineNo" readonly="true" [id]="parseToId('poLineNo')" />
            </div>
          </ng-container>
          <ng-container *ngIf="showCustFields">
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('cust')">{{
                "field.cust" | translate
                }}</label>
              <input type="text" pInputText [ngModel]="cust" readonly="true" [id]="parseToId('cust')" />
            </div>
          </ng-container>
          <ng-container *ngIf="showRequestorFields">
            <div class="col-12 md:col-3 lg:col-3">
              <label [for]="parseToId('requestor')">{{
                "field.requester" | translate
                }}</label>
              <input type="text" pInputText [ngModel]="requestor" readonly="true" [id]="parseToId('requestor')" />
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <!-- Detail Menu Bar -->
    <p-menubar *ngIf="detailMenubarVisible()" [model]="detailMenu" class="bpaas-detail-menubar"
      [id]="parseToId('detailMenu')">
      <b>{{ 'label.total' | translate }} {{ 'field.in-qty' | translate }}:</b> {{ totalInQty }} |
      <b>{{ 'label.total' | translate }} {{ 'field.out-qty' | translate }}:</b> {{ totalOutQty }}
    </p-menubar>

    <!-- Table Tab Menu -->
    <p-tabMenu #detailTabMenuComponent [model]="detailTabs" styleClass="bpaas-table-tabmenu"
      (activeItemChange)="onDetailTabActiveItemChange($event)">
    </p-tabMenu>

    <!-- Table Component -->
    <p-table #tableComponent *ngIf="langChangeVisible" [value]="displayDatas"
      styleClass="p-datatable-gridlines p-datatable-sm p-datatable-striped" [selectionMode]="tableSelectionMode"
      [(selection)]="rowSelectedDatas" [dataKey]="rowDataKeyName" [selectionPageOnly]="true" [paginator]="true"
      [paginatorDropdownAppendTo]="'body'" [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="{{
        'table.paginator'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      }}" [rowsPerPageOptions]="[10, 20, 50]" scrollHeight="75vh" [scrollable]="true"
      (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
      (onHeaderCheckboxToggle)="onHeaderCheckboxToggle()" stateStorage="session" [stateKey]="tableStateStorageName"
      [resizableColumns]="true" columnResizeMode="expand" [columns]="selectedColumns"
      [detailInViewStatus]="detailInViewStatus()" (onStateSave)="onDetailTableStateSave($event)"
      (onFilter)="onDetailTableFilter($event)">
      <!-- Table Header -->
      <ng-template pTemplate="header" let-columns>
        <tr id="bpaas-table-header">
          <!-- Table Header Checkbox -->
          <th scope="col" alignFrozen="left" pFrozenColumn style="
              min-width: 42px !important;
              max-width: 42px !important;
              width: 42px !important;
              text-align: center;
            ">
            <p-tableHeaderCheckbox *ngIf="tableSelectionMode == 'multiple'"
              [id]="parseToId('tableHeaderCheck')"></p-tableHeaderCheckbox>
          </th>
          <!-- Table Header Columns -->
          <th *ngFor="let column of columns" [pSortableColumn]="column.sortable ? column.field : ''"
            [pSortableColumnDisabled]="column.sortable ? false : true"
            [style]="column.width ? 'width: ' + column.width + 'px' : ''" pResizableColumn>
            <label [class]="column.required ? 'bpaas-required' : ''">
              {{ column.header | translate }}
            </label>
            <p-sortIcon *ngIf="column.sortable" [field]="column.field"></p-sortIcon>
          </th>
        </tr>

        <!-- Table Header Filter -->
        <tr *ngIf="tableFilterShow">
          <th alignFrozen="left" pFrozenColumn>&nbsp;</th>
          <th *ngFor="let column of columns">
            <ng-container *ngIf="column.filter">
              <ng-container [ngSwitch]="column.filter.type">
                <p-columnFilter [type]="column.filter.type" [field]="
                    column.filter.field ? column.filter.field : column.field
                  " [matchMode]="
                    column.filter.matchMode
                      ? column.filter.matchMode
                      : 'contains'
                  " styleClass="w-full" [showClearButton]="false" [showButtons]="false"
                  [showMenu]="column.filter.type == 'dropdown' ? false : true">
                  <!-- Table Header Dropdown Filter -->
                  <ng-template *ngIf="column.filter.type == 'dropdown'" pTemplate="filter" let-value
                    let-filter="filterCallback">
                    <p-dropdown [ngModel]="value" [options]="column.filter.options"
                      optionLabel="{{ 'label' | translateFieldName : 'label' }}" optionValue="value" placeholder="Any"
                      (onChange)="filter($event.value)" [showClear]="true" appendTo="body">
                    </p-dropdown>
                  </ng-template>

                  <!-- Table Header Date Filter -->
                  <ng-template *ngIf="column.filter.type == 'date'" pTemplate="filter" let-value
                    let-filter="filterCallback">
                    <p-calendar #calendar [ngModel]="value" (onSelect)="filter(calendar.value)"
                      (keydown.enter)="filter(calendar.value)" dateFormat="yy/mm/dd" dataType="string" appendTo="body">
                    </p-calendar>
                  </ng-template>
                </p-columnFilter>
              </ng-container>
            </ng-container>
          </th>
        </tr>
      </ng-template>

      <!-- Table Body -->
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
        <tr [id]="parseToId('rowData-' + rowIndex)">
          <!-- Table Body Checkbox or RadioButton Column -->
          <td alignFrozen="left" pFrozenColumn style="
              min-width: 42px !important;
              max-width: 42px !important;
              width: 42px !important;
              text-align: center;
            ">
            <p-tableRadioButton *ngIf="tableSelectionMode == 'single'" [value]="rowData"
              [id]="parseToId('rowData-' + rowIndex + '-radio')"></p-tableRadioButton>
            <p-tableCheckbox *ngIf="tableSelectionMode == 'multiple'" [value]="rowData"
              [id]="parseToId('rowData-' + rowIndex + '-check')"></p-tableCheckbox>
          </td>
          <!-- Table Body Data Display -->
          <td *ngFor="let column of columns" [ngClass]="{'delivery-col': column.field === 'deliverySoIsoAdPrIr'}"
            [class]="column.numberField ? 'bpaas-align-right' : ''"
            [id]="parseToId('rowData-' + rowIndex + '-' + column.field)">
            <div [ngClass]="{
                'scrollable-cell': column.field === 'deliverySoIsoAdPrIr'
              }">
              <ng-container *ngIf="column.translateDataValueField">
                {{
                rowData[column.field]
                | translateDataValue
                : rowData
                : column.translateDataValueField
                }}
              </ng-container>
              <ng-container *ngIf="column.translateArrayValue">
                {{
                rowData[column.field]
                | translateArrayValue
                : column.translateArrayValue.datas
                : column.translateArrayValue.valueField
                : column.translateArrayValue.displayField
                }}
              </ng-container>
              <ng-container *ngIf="column.numberField">
                {{
                rowData[column.field] ??
                (column.numberFieldDefaultZero ? 0 : "") | dynamicDecimal
                }}
              </ng-container>
              <ng-container *ngIf="column.dateField">
                {{
                rowData[column.field]
                | date
                : (column.dateFormat ? column.dateFormat : "yyyy/MM/dd")
                : "GMT+8"
                }}
              </ng-container>
              <ng-container *ngIf="column.customField">
                <!-- 如果有需要條件判斷處理值的，自己寫在這段裡面 -->
              </ng-container>
              <ng-container *ngIf="
                  !column.customField &&
                  !column.translateDataValueField &&
                  !column.translateArrayValue &&
                  !column.numberField &&
                  !column.dateField
                ">
                {{ rowData[column.field] }}
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="tableColumns.length + (showActions ? 2 : 1)">
            {{ "table.no-records-found" | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-panel>
</div>